import AxiosClient from './axios-client'

class VideosService {
	getAllVideos() {
		return AxiosClient.get('Video/getAll')
	}
}

export default new VideosService()
